import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Container, Row, Col, Button, Modal, ToggleButton, ToggleButtonGroup } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../../context/auth/useAuth'
import { addBusiness, getBusinesses, editBusiness, addDocument, deleteDocument, enableBusiness, disableBusiness } from '../../../actions/businessesActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../../components/loaders/Loader'
import BusinessForm from '../../../components/forms/BusinessForm'
import BusinessDocumentsForm from '../../../components/forms/BusinessDocumentsForm'

export default function Businesses({typeBusiness = 'provider'}) {
    const { t } = useTranslation()
    const location = useLocation()
    const dispatch = useDispatch()
    const {client} = useAuth()

    const {businesses, resultbusiness, loading} = useSelector(state=>state.businesses)

    const [modalShow, setModalShow] = useState(false)
    const [modalShowDocument, setModalShowDocument] = useState(false)
    const [formState, setFormState] = useState({})
    const [formStateDocument, setFormStateDocument] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)
    const [filterActive, setFilterActive] = useState(true)

    useEffect(() => {
        if(client){
            dispatch(getBusinesses(typeBusiness))
        }
    },[dispatch, t, client])

    useEffect(() => {
        // Ejecuta lógica cuando la URL cambia
        if(client){
            dispatch(getBusinesses(typeBusiness))
        }
    }, [location])

    const openModal = () =>{
        setIsAddingOrEditing('adding')
        setFormState({
            identifier: '',
            name: '',
            companyName: '',
            contact: '',
            address: '',
            cp: '',
            location: '',
            province: '',
            commercialAddress: '',
            commercialCp: '',
            commercialLocation: '',
            commercialProvince: '',
            phone: '',
            cif: '',
            iscc: false,
            others: '',
        })
        setModalShow(true)
    }

    const selectBusiness = (business) => {
        setIsAddingOrEditing('editing')
        setFormState(business)
        setModalShow(true)
    }
    const selectBusinessDocument = (business) => {
        setFormStateDocument({
            businessId: business._id,
            businessName: business.name,
            documentDescription: '',
            documentUrl: '',
            documents:business.documents
        })
        setModalShowDocument(true)
    }

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }
    const handleInputDocumentChange = ({target})=>{
        setFormStateDocument({
            ...formStateDocument,
            [target.name]: target.value
        })
    }
    const handleFileChange = ({target})=>{
        setFormStateDocument({
            ...formStateDocument,
            [target.name]: target.files[0]
        })
    }

    const handleCheckboxChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.checked
        })
    }

    const handleDeleteDocument = async(document, business) => {

        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.yes'),
            denyButtonText: t('global.no'),
            icon: 'question',
            text:  t('admin.businesses.areyousuredeletedocument')
        }).then((resultuser) => {
            if (resultuser.isConfirmed) {
                dispatch(deleteDocument(document, business))
            }
        })
    }

    const handleSubmit= async(e) => {
        e.preventDefault()
        setIsRegistering(true)

        if(isAddingOrEditing==='editing'){
            dispatch(editBusiness(formState, formState._id))
        }else{
            dispatch(addBusiness(formState,typeBusiness))
        }
        setIsRegistering(false)
    }

    const handleSubmitDocument= async(e) => {
        e.preventDefault()
        setIsRegistering(true)
        dispatch(addDocument(formStateDocument, formStateDocument.businessId))
        setIsRegistering(false)
    }

    const disableEnableBusinesses = async(e) => {
        e.preventDefault()
        let textQuestion = ''
        formState.active
            ?
                textQuestion = t('admin.businesses.areyousuredisable')+'<br><p><label className="fs-20 fw-600 pt-5">'+formState?.name+'</label></p>'
            :
                textQuestion = t('admin.businesses.areyousureenable')+'<br><p><label className="fs-20 fw-600 pt-5">'+formState?.name+'</label></p>'

        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.accept'),
            denyButtonText: t('global.cancel'),
            html: textQuestion
        }).then((result) => {
            if (result.isConfirmed) {
                if (formState.active) {
                    dispatch(disableBusiness(formState._id))
                }else{
                    dispatch(enableBusiness(formState._id))
                }
            }
        })
    }

    useEffect(() => {
        if(resultbusiness){
            let resultbusinessTemp = resultbusiness
            dispatch({ type: 'PROVIDER_RESET_RESULT'})
            switch (resultbusinessTemp) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.businesses.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'successedit':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.businesses.editsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setModalShowDocument(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'successDeleteDocument':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.businesses.deletesuccess')
                    }).then(() => {
                        setModalShowDocument(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'successenable':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.businesses.enablesuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'successdisable':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.businesses.disablesuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'identifier':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'warning',
                        text: t('admin.businesses.exist')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultbusiness])

    const columnsBusinesses = [
        {
            name: t('admin.businesses.identifier'),
            width: '120px',
            cell: business =>
                <div className='cursor' onClick={() => selectBusiness(business)}>
                    {business.identifier}
                </div>,
            selector: (business) => business.identifier,
            sortable: true,
        },{
            name: t('admin.businesses.name'),
            grow: 2,
            style: { minWidth: '240px', alignItems: 'center' },
            wrap: true,
            cell: business =>
                <div className='cursor text-start' onClick={() => selectBusiness(business)}>
                    {business.name}<br/><small>{business.companyName}</small>
                </div>,
            selector: (business) => business.name,
            sortable: true,
        },{
            name: t('admin.businesses.address'),
            grow: 3,
            style: { minWidth: '280px', alignItems: 'center' },
            wrap: true,
            cell: business =>
                <div className='cursor text-start' onClick={() => selectBusiness(business)}>
                    {business.address}
                </div>,
            selector: (business) => business.address,
            sortable: true,
        },{
            name: t('admin.businesses.cp'),
            style: { minWidth: '120px',  alignItems: 'center' },
            cell: business =>
                <div className='cursor text-center' onClick={() => selectBusiness(business)}>
                    {business.cp}
                </div>,
            selector: (business) => business.cp,
            sortable: true,
        },{
            name: t('admin.businesses.location'),
            grow: 2,
            style: { minWidth: '200px', alignItems: 'center' },
            wrap: true,
            cell: business =>
                <div className='cursor text-start' onClick={() => selectBusiness(business)}>
                    {business.location} {business.province ? <>({business.province})</> : ''}
                </div>,
            selector: b => `${b.location} ${b.province ?? ''}`.trim(),
            sortable: true,
        },{
            name: '',
            width: '100px',
            style: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
            cell: business =>
                <>

                    <div className='cursor' onClick={() => selectBusinessDocument(business)}>
                        <i className='fas fa-paperclip'></i> {business.documents?.length > 0 ? business.documents.length : ''}
                    </div>
                </>,
            sortable: false,
        }
    ]
    const ExpandedRow = ({ data }) => {
        return (
            <Container className='p-3'>
                <Row>
                    <Col xs={12} lg={6}>
                        <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                            <small>{t('admin.businesses.cif')}</small> {data?.cif}
                        </div>
                        <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                            <small>{t('admin.businesses.companyName')}</small> {data?.companyName}
                        </div>
                        <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                            <small>{t('admin.businesses.contact')}</small> {data?.contact}
                        </div>
                    </Col>
                    <Col xs={12} lg={6}>
                        <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                            <small>{t('admin.businesses.email')}</small> {data?.email}
                        </div>
                        <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                            <small>{t('admin.businesses.phone')}</small> {data?.phone}
                        </div>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col xs={12} lg={6} className="my-2">
                        <div className="border rounded p-2 h-100">
                            <h6 className="text-uppercase text-muted mb-2">{t('admin.businesses.fiscaladdresssection')}</h6>
                            <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                                <small>{t('admin.businesses.address')}</small> {data?.address}
                            </div>
                            <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                                <small>{t('admin.businesses.cp')}</small> {data?.cp}
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} lg={6} className="my-2">
                        <div className="border rounded p-2 h-100">
                            <h6 className="text-uppercase text-muted mb-2">{t('admin.businesses.commercialaddresssection')}</h6>
                            <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                                <small>{t('admin.businesses.commercialAddress')}</small> {data?.commercialAddress}
                            </div>
                            <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                                <small>{t('admin.businesses.commercialCp')}</small> {data?.commercialCp}
                            </div>
                            <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                                <small>{t('admin.businesses.commercialLocation')}</small> {data?.commercialLocation} {data?.commercialProvince ? <>({data.commercialProvince})</> : ''}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }

    const filteredBusinesses = businesses?.filter(business => business?.active === filterActive)

    return (
        <Container className='mt-5 px-0'>
            <Row>
                <Col xs={12} className='text-center'>
                    <h1>
                        {t(`admin.businesses.${typeBusiness}`)}&nbsp;
                        {filterActive
                            ?
                            t('admin.businesses.businessesenabled')
                            :
                            t('admin.businesses.businessesdisabled')
                        }
                    </h1>
                </Col>
                <Col xs={6} className='d-flex justify-content-start'>
                    <ToggleButtonGroup
                        type="radio"
                        name="filterActive"
                        value={filterActive}
                        onChange={setFilterActive}
                    >
                        <ToggleButton id="tbg-active" value={true} variant="outline-success">
                            {t('admin.businesses.enabled')}
                        </ToggleButton>
                        <ToggleButton id="tbg-inactive" value={false} variant="outline-danger">
                            {t('admin.businesses.disabled')}
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Col>
                <Col xs={6} className='d-flex justify-content-end'>
                    <Button variant='primary' type="submit" className="my-2 cursor" onClick={() => openModal()}>
                        {t('admin.businesses.createbusiness')}
                    </Button>
                </Col>
            </Row>
            {
                loading
                    ?
                        <Loader/>
                    :

                        <Row>
                            <Col>
                            {filteredBusinesses?.length > 0
                                ?
                                    <CustomDataTable
                                        columns={columnsBusinesses}
                                        data={filteredBusinesses}
                                        exportable={true}
                                        printable={true}
                                        expandedData={ExpandedRow}
                                    />
                                :
                                    <h4 className='mt-4'>{t('admin.businesses.thereisnotbusinesses')}</h4>
                            }
                            </Col>
                        </Row>

            }
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t(`admin.businesses.${typeBusiness}`)}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BusinessForm
                        state={formState}
                        handleInputChange={handleInputChange}
                        handleCheckboxChange={handleCheckboxChange}
                        submit={handleSubmit}
                        disableEnableBusinesses={disableEnableBusinesses}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                    />
                </Modal.Body>
            </Modal>
            <Modal
                show={modalShowDocument}
                onHide={() => setModalShowDocument(false)}
                aria-labelledby="contained-modal-title-vcenter-clip"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter-clip">
                        <h2>{formStateDocument?.businessName} - {t('admin.businesses.documents')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BusinessDocumentsForm
                        state={formStateDocument}
                        handleInputChange={handleInputDocumentChange}
                        handleFileChange={handleFileChange}
                        handleDeleteDocument={handleDeleteDocument}
                        submit={handleSubmitDocument}
                        isRegistering={isRegistering}
                    />
                </Modal.Body>
            </Modal>
        </Container>
    )
}